import { Injectable } from "@angular/core";
import { GamingAppCommand } from "@fabric-types/app-gaming";
import { PreferencesSettings } from "@obg/common.config/src/common/preferences-settings";
import { CR0SS_SELL_FEATURE_FLAG_KEY } from "@obg/gaming.sportsbook/ui/sportsbook-iframe/sportsbook-iframe.const";
import { ChangePasswordModel } from "@obg/ngx.common/types";
import { DocumentRef, FeatureFlagService } from "@obg/ngx.global";
import { Observable } from "rxjs";

import { AccountSettingsClient } from "./account-settings.client";
import { AccountSettingsConfigService } from "./account-settings.config";
import { OptimizelyDefaultFlag } from "./account-settings.model";

@Injectable({
	providedIn: "root",
})
export class AccountSettingsService {
	constructor(
		private config: AccountSettingsConfigService,
		private client: AccountSettingsClient,
		private featureFlagService: FeatureFlagService,
		private documentRef: DocumentRef
	) {}

	changePassword(model: ChangePasswordModel): Observable<object> {
		return this.client.changePassword(model);
	}
	async fetchIsCrossSellVisible() {
		const isCrossSellFeatureFlagEnabled =
			this.featureFlagService.get<OptimizelyDefaultFlag | undefined>(CR0SS_SELL_FEATURE_FLAG_KEY)?.enabled ??
			false;

		const isCrossSellFeatureAvailable = await new Promise<boolean>((resolve) => {
			this.documentRef.obgEventBus.dispatch(GamingAppCommand.GetCrossSellFeatureStatus, {
				onSuccess: () => {
					resolve(true);
				},
				onError: () => {
					resolve(false);
				},
			});
		});

		return isCrossSellFeatureFlagEnabled && isCrossSellFeatureAvailable;
	}

	async getPreferencesSettings(): Promise<string[]> {
		let preferencesSettings = this.config.getPreferencesSettings();

		const showCrossSellSetting = await this.fetchIsCrossSellVisible();

		if (!showCrossSellSetting) {
			preferencesSettings = preferencesSettings.filter((setting) => setting !== PreferencesSettings.CrossSell);
		}

		return preferencesSettings;
	}
}
